$(function () {
  // Tooltip in navigation bar

  app.tooltipNavbar = new jBox('Tooltip', {
    addClass: 'tooltip-dark',
    attach: '[data-tooltip-navbar]',
    getContent: 'data-tooltip-navbar',
    delayOpen: 800,
    adjustTracker: true,
    position: {
      x: 'center',
      y: 'bottom'
    },
    offset: {
      y: -4
    },
    animation: 'move',
    zIndex: 9000,
    createOnInit: true
  });

  // Tooltips in list

  app.tooltipRow = new jBox('Tooltip', {
    addClass: 'tooltip-dark',
    attach: '[data-tooltip-row]',
    getContent: 'data-tooltip-row',
    delayOpen: 800,
    position: {
      x: 'center',
      y: 'top'
    },
    offset: {
      y: 4
    },
    animation: 'move',
    zIndex: 9000,
    createOnInit: true,
    onOpen: function () {
      if (this.source.attr('data-tooltip-row') == 'toggle') {
        this.content.html(
          this.source.hasClass('list-item__icon--toggle-admin') ? ($('body').attr('data-user-role') == 'admin' ? 'Freigeben' : 'Auf Freigabe warten') : (
            this.source.parents('.list-item__row').attr('data-active') == '1'
              ? 'Deaktivieren'
              : 'Aktivieren'
          )
        );
      }

      const table = this.source.parents('.list-items__wrapper').attr('data-name-single') == 'Hashtag' ? 'hashtags' : 'sticky';

      const tooltipTextAdd = table == 'hashtags' ? 'Zu Top-Tags hinzufügen' : 'Als Topbeitrag auf der Startseite anzeigen';
      const tooltipTextRemove = table == 'hashtags' ? 'Von Top-Tags entfernen' : 'Von Startseite entfernen';

      if (this.source.attr('data-tooltip-row') == 'sticky') {
        this.content.html(
          this.source.parents('.list-item__row').attr('data-sticky') == '1' ? tooltipTextRemove : tooltipTextAdd
        );
      }
    }
  });

  // Tooltips in editor

  app.tooltipEditor = new jBox('Tooltip', {
    addClass: 'tooltip-dark',
    attach: '[data-tooltip-editor]',
    getContent: 'data-tooltip-editor',
    delayOpen: 800,
    position: {
      x: 'center',
      y: 'top'
    },
    offset: {
      y: 4
    },
    animation: 'move',
    zIndex: 9000,
    createOnInit: true
  });

  // Tooltips in file input header

  app.fileInputHeaderTooltip = new jBox('Tooltip', {
    addClass: 'tooltip-dark',
    attach: '[data-file-header-icon-tooltip]',
    getContent: 'data-file-header-icon-tooltip',
    delayOpen: 800,
    position: {
      x: 'center',
      y: 'top'
    },
    offset: {
      y: 4
    },
    animation: 'move',
    zIndex: 9000
  });

  // Input tooltip

  app.fileInputHeaderTooltip = new jBox('Tooltip', {
    addClass: 'tooltip-dark',
    attach: '[data-input-tooltip]',
    getContent: 'data-input-tooltip',
    position: {
      x: 'center',
      y: 'top'
    },
    offset: {
      y: 6
    },
    pointer: 'left:6',
    animation: 'move',
    zIndex: 9000
  });

  // Media library

  app.tooltipMediaLibraryView = new jBox('Tooltip', {
    addClass: 'tooltip-dark',
    attach: '[data-tooltip-ml-view]',
    getContent: 'data-tooltip-ml-view',
    delayOpen: 800,
    adjustTracker: true,
    position: {
      x: 'center',
      y: 'bottom'
    },
    offset: {
      y: -6
    },
    pointer: 'left:6',
    animation: 'move',
    zIndex: 9000
  });

  // Tooltip for input description

  app.tooltipInputDescription = new jBox('Tooltip', {
    addClass: 'tooltip-dark -multiline',
    attach: '[data-input-description]',
    adjustTracker: true,
    maxWidth: 320,
    position: {
      x: 'center',
      y: 'bottom'
    },
    pointer: 'right:6',
    animation: 'move',
    zIndex: 9000,
    createOnInit: true,
    onOpen: function () {
      var content = this.source.find('.input__description-text').html();
      this.setContent(content);
    }
  });
});
